export enum InterestedPartiesFormNamesEnum {
  FORM_GROUP_NAME = 'InterestedParties',
  PARTIES = 'Parties',
  ADD_PARTY = 'AddParty',
  REMOVE_PARTY = 'RemoveParty',
}
